export default __webpack_public_path__ + "static/media/feature 2.7ff50f27.png";